import { gql } from "@apollo/client";

export const USER_PASSWORD_RESET_EMAIL = gql`
  mutation UserPasswordResetEmail($email: String!) {
    userPasswordResetEmail(email: $email)
  }
`;

export const USER_UNAUTHENTICATED_PASSWORD_RESET = gql`
  mutation UserUnauthenticatedPasswordReset(
    $password: String!
    $token: String!
    $email: String!
  ) {
    userUnauthenticatedPasswordReset(
      password: $password
      token: $token
      email: $email
    )
  }
`;
